import {useFusionAuth} from "@fusionauth/react-sdk";

declare global {
    interface Window { refreshToken: any; }
}

const useFusionAuthRefreshToken = () =>{

    const {refreshToken} = useFusionAuth()

    const init = () => {

        //Put refreshToken method on Window so it can be used appwide
        if(refreshToken){
            window.refreshToken = refreshToken
        }
    }


    return {init}
}

export default useFusionAuthRefreshToken